import { S3 } from 'aws-sdk';
import httpClient from '../../HttpClient';
import { API_BASE } from '../../AppUtil';

var accessKeyId = "INVALID_KEY"; // process.env['REACT_APP_S3_KEY'];
var clientSecret = "INVALID_SECRET"; // process.env['REACT_APP_S3_SECRET'];

class S3Instance {
    bucket: string = '';

    constructor() {
    }

    uploadFile(file: File, key: string, callback: any) {

        const reader = new FileReader();

        let bucket = this.bucket;

        reader.onloadend = function () {

            if(reader.result === null) {
                callback(null);
                return;
            }

            const base64Data = reader.result.toString().split(',')[1];

            httpClient.post(API_BASE + '/util/uploadS3File', {
                key: key,
                file: base64Data
            }).then((response) => {
                if (response.status === 200) {
                    callback(null);
                }
            }).catch((error) => {
                callback(null);
            });

        };

        reader.readAsDataURL(file);

    }
}


export const s3Instance = new S3Instance();